import React from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import Heading from '../../../components/ui/heading'
import Anchor from '../../../components/ui/anchor'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import SectionTitle from '../../../components/ui/section-title'
import FeatureBox from '../../../components/box-image/layout-one'
import { SectionWrap, SectionBottom } from './services-area.style'
import BoxIcon from '../../../components/box-icon/layout-two'

const ServicesArea = (props) => {
    const featuredDataQuery = useStaticQuery(graphql`
        query ITServicesQueryData {
            allItServicesJson(sort: {id: DESC}, limit: 6) {
                edges {
                  node {
                    fields {
                        slug
                    }
                    id
                    title
                    excerpt
                    # icon {
                    #   img{
                    #     childImageSharp{
                    #         fixed(width:100, height: 108, quality: 100 ){
                    #             ...GatsbyImageSharpFixed_tracedSVG
                    #         }
                    #     }
                    #   }
                    # }
                    icon {
                        svg {
                        publicURL
                        }
                    }
                  }
                }
            }
        }
    `);
    const featureData = featuredDataQuery.allItServicesJson.edges;
    const { linkStyle, headingStyle } = props;
    return (
        <SectionWrap>
            <Container>
                <Row>
                    <Col lg={12}>
                        <SectionTitle
                            subtitle="Our Services"
                            title="<span>Invent</span>, <span>build</span>, <span>integrate</span>, <span>scale</span> and <span>upgrade</span> your applications with us!"
                        />
                    </Col>
                </Row>
                <Row>
                    {featureData.map(feature => (
                        <Col lg={4} md={6} className="box-item" key={feature.node.id}>
                            <BoxIcon
                                id={feature.node.id}
                                title={feature.node.title}
                                desc={feature.node.excerpt}
                                icon={feature.node.icon}
                                path={`/services/${feature.node.fields.slug}`}
                            />
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col lg={12}>
                        <SectionBottom>
                            <Heading {...headingStyle}>Want to know how we can assist you? <Anchor {...linkStyle} path="/free-consultation">Schedule a free consultation!</Anchor></Heading>
                        </SectionBottom>
                    </Col>
                </Row>
            </Container>
        </SectionWrap>
    )
}

ServicesArea.propTypes = {
    headingStyle: PropTypes.object,
    linkStyle: PropTypes.object
}

ServicesArea.defaultProps = {
    headingStyle: {
        as: 'h3',
        fontSize: '18px',
        fontweight: 500,
        lineHeight: 1.40,
        color: '#333333'
    },
    linkStyle: {
        layout: 'underline',
        hover: {
            layout: 2
        }
    }
}

export default ServicesArea;